"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var UnorderedList = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 16px 0;\n  padding-inline-start: 0;\n  color: ", ";\n  font-size: ", ";\n\n  & > li {\n    padding: ", ";\n  }\n"], ["\n  margin: 16px 0;\n  padding-inline-start: 0;\n  color: ", ";\n  font-size: ", ";\n\n  & > li {\n    padding: ", ";\n  }\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.list.color;
}, function (_a) {
    var condensed = _a.condensed;
    return (condensed ? '12px' : '20px');
}, function (_a) {
    var condensed = _a.condensed;
    return (condensed ? '6px 0' : '12px 0');
});
UnorderedList.displayName = 'UnorderedList';
exports.ListItem = styled_components_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  list-style: none;\n  border-bottom: 1px solid ", ";\n  &:first-of-type {\n    border-top: 1px solid ", ";\n  }\n"], ["\n  list-style: none;\n  border-bottom: 1px solid ", ";\n  &:first-of-type {\n    border-top: 1px solid ", ";\n  }\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.list.borderColor;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.list.borderColor;
});
exports.ListItem.displayName = 'ListItem';
var List = function (_a) {
    var children = _a.children, condensed = _a.condensed, testID = _a.testID;
    return (react_1.default.createElement(UnorderedList, { condensed: condensed, "data-test-id": testID }, children));
};
List.displayName = 'List';
exports.default = List;
var templateObject_1, templateObject_2;
//# sourceMappingURL=list.component.js.map